import { useTranslation } from 'react-i18next';

import { REEL_SESSION_COLUMNS } from './columns';

/** The columns hide at the same breakpoints their values do, so a label never stands over nothing. */
export const ReelSessionRowHeader = () => {
  const { t } = useTranslation('reelsCreator');

  return (
    <div
      data-testid="reel-session-row-header"
      className="flex items-center gap-sm border-b border-border px-xs py-xs text-body-sm font-medium text-muted-foreground"
    >
      <div className="flex min-w-0 flex-1 items-center gap-sm">
        <span className="w-14 shrink-0" aria-hidden />
        <span className="min-w-0 flex-1">{t('reelsSessionList.reelSessionRowHeader.reels')}</span>
        <span className={`hidden shrink-0 sm:block ${REEL_SESSION_COLUMNS.status}`}>
          {t('reelsSessionList.reelSessionRowHeader.status')}
        </span>
        <span className={`hidden shrink-0 md:block ${REEL_SESSION_COLUMNS.created}`}>
          {t('reelsSessionList.reelSessionRowHeader.created')}
        </span>
        <span className={`hidden shrink-0 lg:block ${REEL_SESSION_COLUMNS.owner}`}>
          {t('reelsSessionList.reelSessionRowHeader.owner')}
        </span>
      </div>
      <span className={`shrink-0 ${REEL_SESSION_COLUMNS.actions}`} aria-hidden />
    </div>
  );
};
